import { useState } from "react"

import Product from "../../../components/choose-plan/components/product"

import ProductDetailsDialog from "./product-details-dialog"

const ProductList = ({ products, className }) => {
  const [dialogData, setDialogData] = useState(null)

  return (
    <>
      {products.map((product, index) => (
        <Product
          key={index}
          onClick={() => setDialogData(product.details)}
          data-component-name="web-portal-plan-selection-product"
          {...product}
          sx={{
            borderColor: "#E1E1E1",
            "&:not(:last-of-type)": {
              mb: 2,
            },
            "& > svg": {
              mr: 0,
            },
          }}
          className={className}
        />
      ))}

      <ProductDetailsDialog
        {...dialogData}
        isOpen={!!dialogData}
        onDismiss={() => setDialogData(null)}
      />
    </>
  )
}

export default ProductList
